const uuid = require('uuid')
uuid
import productItems from '../../assets/data/productDB.json'

const state = {
    productItems: [
        ... productItems,
        {
            productNo: "00000",
            productName: "Custom controller",
            systemCategory: "bms",
            daliCurrentNeed: 0,
            daliType: "applicationControllerPower",
            maxShortAddress: null,
            maxEcg: 64,
            maxSensors: 12,
            daliPower: 180,
            daliPowerPeak: 210,
            isPowerExtendable: false,
            dacoSingleMasterWork: false,
            dacoMultiMasterWork: false,
            casambiWork: false,
            knxLinkGatewayWork: false,
            daliLinkWork: false,
            buildingManagementWork: true,
            active: false,
            slaveSensorTechnologie: "bms",
            slaveInputTechnologie: "bms"
          }
    ]
}



const mutations = {
    ACTIVATE_APPLICATION_CONTROLLER(state, payload) {
        state.productItems.map((obj) =>  {
            if(obj.productNo != payload.productNo) {
                obj.active = false
            }
        } )
        let index = state.productItems.findIndex(obj => obj.productNo == payload.productNo);
        state.productItems[index] = payload;
    },
    RESET_APPLICATION_CONTROLLER(state) {
        for(let product of state.productItems) {
            product.active = false
        }
    }
};

const actions = {
    selectApplicationController({commit}, payload) {
        //const valueBefore = payload.active
        // TOGGLE DERZEIT DEAKTIVIERT
        let value = true
/*         if(valueBefore === true) {
            value = false
        } */
        payload.active = value
        commit('ACTIVATE_APPLICATION_CONTROLLER', payload)
    },
    resetApplicationController({commit}) {
        commit('RESET_APPLICATION_CONTROLLER')
    }
};

const getters = {
    getAll: state => state.productItems,
    getAllApplicationController: (state) => {
        return state.productItems.filter(obj => (obj.daliType == "applicationControllerPower" || obj.daliType == "powerSupply"))
    },
    getSelectedApplicationController: (state) => {
        return state.productItems.find(obj => (obj.active == true))
    },
    getCustomController: (state) => {
        return state.productItems.find(obj => obj.productNo == "00000")
    }
};

const namespaced = true;

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced
};
